export var Role;
(function (Role) {
    Role["ADMIN"] = "admin";
    Role["EDITOR"] = "editor";
    Role["USER"] = "user";
})(Role || (Role = {}));
export var AccountType;
(function (AccountType) {
    AccountType["FREE"] = "free";
    // PLUS = 'plus',
    AccountType["PRO"] = "pro";
    AccountType["PRO_MONTHLY"] = "pro_monthly";
    AccountType["PRO_YEARLY"] = "pro_yearly";
})(AccountType || (AccountType = {}));
